import { Checklist, LoaderLayout } from '@app/components';
import { useTranslation } from '@hopin-team/provider-translation';
import React from 'react';

import { ContentTypeCardList, ToneOfVoiceSelector } from '../components';
import { useContentComposerLoadingState } from '../hooks';

// TODO(post-event-enable-creator-lab-consolidation): Remove feature flag once fully rolled out
export const Landing = () => {
  const { t } = useTranslation();
  const { phase, loaderLayoutProps, checklistItems } =
    useContentComposerLoadingState();

  // Show loader states (loading, post-processing, ineligible)
  // Note: 'no-license' phase is handled by editor-page.tsx (shows UpgradeBanner)
  if (phase !== 'ready' && loaderLayoutProps) {
    return (
      <div className="h-full px-4 py-6">
        <LoaderLayout
          {...loaderLayoutProps}
          rightContent={
            checklistItems.length > 0 ? (
              <Checklist items={checklistItems} />
            ) : undefined
          }
        />
      </div>
    );
  }

  // Ready: show normal content composer UI
  return (
    <div className="h-full overflow-y-auto px-4 flex flex-col gap-4">
      <div className="p-0">
        <div className="flex items-center gap-4">
          <p className="m-0 text-[17px] font-medium leading-[1.47] text-white">
            {t('content-recording.content-composer.title')}
          </p>
          <span className="h-4 px-1 text-[10px] font-bold leading-none bg-spring-primary text-white rounded-full border border-spring-neutral-base flex items-center justify-center shrink-0">
            {t('content-recording.content-composer.new-badge')}
          </span>
        </div>
      </div>
      <p className="text-xs leading-[1.5] text-spring-neutral-b3 mb-0">
        {t('content-recording.content-composer.description')}
      </p>
      <p className="text-xs leading-[1.5] font-semibold text-spring-neutral-b0 mb-0">
        {t('content-recording.content-composer.ai-generated-content')}
      </p>

      <ToneOfVoiceSelector />

      <ContentTypeCardList />
    </div>
  );
};
